import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, createElement } from "lwc";
import _tmpl from "./editDropDown.html";
import LightningElementSLDS from "util/lightningElementSLDS";
import { eventTypes, fireEvent, registerListener } from "../../util/pubsub/pubsub";
import lightningButtonIcon from "lightning/buttonIcon";
class editDropDown extends LightningElementSLDS {
  constructor(...args) {
    super(...args);
    this.dropdowns = [];
    this.dropDownEditList = [];
    this.defaultDropdown = [];
    this.displaydropDownEditList = false;
    this.editdropdownDialog = void 0;
    this.title = void 0;
    this.preSelectedValue = void 0;
    this.lightningButtonIcon = lightningButtonIcon;
    this.displayText = false;
    this.pageRef = {
      attributes: {
        developer: "zPaper",
        application: "Document Viewer"
      }
    };
    this.deletedDropdown = [];
    this.isRendered = false;
    this.btnObj = void 0;
  }
  /**
   * 
   * @param {*} dialogParams 
   * This method is reposible for initializing the jQuery Dialog which displays the Edit Dropdown UI
   */
  initEditDialog(dialogParams) {
    let self = this;
    let myInterval = setInterval(function () {
      this.btnObj = dialogParams;
      if (!self.editdropdownDialog && self.isRendered) {
        self.editdropdownDialog = $(self.template.querySelector(".editDropdownPanel")).dialog(dialogParams);
        console.log("self.template.querySelector('select').value ", self.template.querySelector('select').value);
        self.template.querySelector('select').dataset.value = self.template.querySelector('select').value;
        clearInterval(myInterval);
      }
    }, 100);
  }

  /**
   * 
   * @param {*} values - this is an array of dropdown options [{label: 'v1', value: 'v1'}, {label: 'v2', value: 'v2'}]
   * @param {*} pdfDoc - this is a reference to the pdf document that was used to initially load the 
   * This method sets the drop down values that are displayed in the select element
   */
  setDropdowns(values) {
    this.dropdowns = values;
  }

  /**
   * 
   * @returns the latest set of dropdown values
   */
  getDropdowns() {
    return this.dropdowns;
  }

  /**
   * setting the isRendered flag. This is used to add drop down values to select element
   */
  renderedCallback() {
    console.log("running rendered callback for dropDown component");
    this.isRendered = true;
  }

  /**
   * 
   * @param {*} handler - this should be a event handler function that will get triggered when the the select value is changed
   */
  handleChange(handler) {
    let dropDownChange = this.template.querySelector('select');
    dropDownChange.addEventListener("change", function (event) {
      try {
        if (handler) {
          //we can use apply or call to set the this value
          handler(event);
        }
      } catch (err) {
        console.error("An error has occured while opening PDF");
      }
    });
  }
  connectedCallback() {
    this.title = __g_title;
  }
}
_registerDecorators(editDropDown, {
  publicProps: {
    defaultDropdown: {
      config: 0
    },
    editdropdownDialog: {
      config: 0
    },
    title: {
      config: 0
    },
    btnObj: {
      config: 0
    }
  },
  publicMethods: ["initEditDialog", "setDropdowns", "getDropdowns", "handleChange"],
  track: {
    dropdowns: 1,
    dropDownEditList: 1
  },
  fields: ["displaydropDownEditList", "preSelectedValue", "lightningButtonIcon", "displayText", "pageRef", "deletedDropdown", "isRendered"]
});
export default _registerComponent(editDropDown, {
  tmpl: _tmpl
});